import Phaser from 'phaser';

export default class GridBackground extends Phaser.GameObjects.Container {
  constructor(scene, blockSize,gridWidth,gridHeight) {
    super(scene);

    const grid = this.scene.add.graphics();
    let i = 0;
    while (i < gridHeight) {
      let j = 0;
      while (j < gridWidth) {
        const color = (i === 0 || i % 2 === 0) && (j === 0 || j % 2 === 0) || (i % 2 === 1 && j % 2 === 1) ? '0xFFFFFF' : '0xCCCCCC';
        grid.fillStyle(color);
        grid.fillRect(j * blockSize,i * blockSize,blockSize,blockSize);
        j++;
      }
      i++;
    }

    this.add(grid);
  }
}